









































import { mapGetters } from 'vuex'
import FeedGrid from '~/components/car/classifieds/index/feeds/FeedGrid.vue'
import FeedRecentButtons from '~/components/car/classifieds/index/feeds/FeedRecentButtons.vue'
import CLocatorButton from '~/components/shared/configurable/location/locator/CLocatorButton.vue'
import RecentFeedMixin from '~/components/car/classifieds/index/feeds/RecentFeedMixin.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { APP_NS } from '~/store/modules/shared/app/state'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { FeedRecentButtons, CLocatorButton, FeedGrid },
  mixins: [RecentFeedMixin],
  props: {
    isLatest: {
      type: Boolean,
      default: true,
      required: false
    },
    maxClassifieds: {
      type: Number,
      required: false,
      default: 500
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, ['isMobile']),
    ...mapGetters(APP_NS, {
      isPlot: 'isPlot'
    })
  }
})
